<template>
    <ul class="ui-fancytree fancytree-container fancytree-plain" role="tree">
        <CategoryTreeItemComponent
            v-for="category in categories"
            :category="category"
            :targetIntegrationService="targetIntegrationService"
            :selectedSourceId="selectedSourceId"
            @update:selectedCategory="$emit('update:selectedCategory', $event)"
        />
    </ul>
</template>
<script>
import CategoryTreeItemComponent from './CategoryTreeItemComponent.vue';

import { httpClient } from '../../../../services/HttpClient';

export default {
    name: 'CategoryTreeComponent',
    components: {
        CategoryTreeItemComponent
    },
    props: {
        targetIntegrationService: {
            type: String,
            required: true
        },
        selectedSourceId: {
            type: Number,
            default: null
        }
    },
    emits: ['update:selectedCategory'],
    data() {
        return {
            categories: []
        }
    },
    methods: {
        async fetchCategories() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/marketplace/sources/${this.targetIntegrationService}/categories`, {
                limit: 100,
                parent_source_id: null,
                orders: [
                    {column : 'name_uk', dir : 'asc'}
                ]
            }).then((response) => {
                this.categories = response.data.data;
            });
        }
    },
    mounted() {
        this.fetchCategories();
    }
};
</script>